import DefaultView from '@plone/volto/components/theme/View/DefaultView';
import CursorTrail from '../CursorTrail/CursorTrail';

const DocumentView = (props) => {
  const { content } = props;
  const cursorTrailEnabled = content.cursor_trail_enabled === true;

  return (
    <>
      <CursorTrail enabled={cursorTrailEnabled} />
      <DefaultView {...props} />
    </>
  );
};

export default DocumentView;
